import { useState } from 'react';
import { IbanInput } from '@popsure/dirty-swan';
import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { Header } from '../../Screen';
import { isValidIban } from './isValidIban';

export const IbanForm = <Questionnaire extends QuestionnaireQuestions>({
  value,
  onSubmitValue,
  ...props
}: QuestionnaireFormProps<Questionnaire, string>) => {
  const [iban, setIban] = useState(value ?? '');
  const [error, setError] = useState('');

  const onChange = (value: string) => {
    if (error) {
      setError('');
    }
    setIban(value);
  };

  const handleSubmit = () => {
    if (!isValidIban(iban)) {
      setError('The IBAN you provided is invalid.');
      return;
    }

    onSubmitValue(iban);
  };

  return (
    <Header onSubmit={handleSubmit}>
      <IbanInput {...props} error={error} onChange={onChange} value={iban} />
    </Header>
  );
};
